import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "input-group",
  style: {"width":"60%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "addon-wrapping"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      onKeyup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('searchPokemon', $event))),
      type: "text",
      class: "form-control",
      placeholder: "search pokemon",
      "aria-label": "search pokemon",
      "aria-describedby": "addon-wrapping"
    }, null, 32)
  ]))
}